import { render, staticRenderFns } from "./error_handler.vue?vue&type=template&id=037d1c08&scoped=true"
import script from "./error_handler.vue?vue&type=script&lang=js"
export * from "./error_handler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d1c08",
  null
  
)

export default component.exports